import React, { useEffect, useRef, useState } from 'react';
import { Outlet, useNavigate, useLocation, Routes, Route, Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { Cookies } from './index.js';
import { FaBars } from 'react-icons/fa';
import { BiChevronLeft } from 'react-icons/bi';
import { alert_error, alert_success } from './AppContext';
import './app_structure/styles.css';
import './app_structure/app.css';
import SupportButton from './community/SupportButton.jsx';
import Footer_app from './app_structure/Footer_app.jsx';
import Footer_web from './app_structure/Footer_web.jsx';
import Navbar from './app_structure/app_fontend/sidebar_main.jsx';
import { useSelector, useDispatch } from 'react-redux';
import { auth, doc, collection, db, getDoc } from './js/firebase.js';
import { update_open_button_support, update_users_status } from './order/orders/actions.js';
import { isLocalHost } from './shared/host_utils.js';
import RouteListener from './app_structure/RouteListener.js';
import NavMain from './app_structure/app_fontend/nav_main.tsx';
import Convert_domain from './shop/mainpage/convert_domain.jsx';
import LocalhostNextAnchorRewrite from './app_structure/app_fontend/a_href.jsx';
import {
  readSidebarCollapsed,
  subscribeSidebarCollapsed,
} from './shared/sidebar_state.js';

function App() {

  const [domain, setDomain] = useState(Cookies.get("main_domain") || "hust");
  const open_button_support = useSelector(state => state.open_button_support);
  const users_status = useSelector(state => state.users_status);
  const dispatch = useDispatch();

  const set_open_button_support = (value) => {
    dispatch(update_open_button_support(value));
  };
  const set_users_status = (value) => {
    dispatch(update_users_status(value));
  };
  const [type_user, settype_user] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const previousLocationRef = useRef(location);
  useEffect(() => {
    if (previousLocationRef.current.pathname == '/reactapp/exchangepoints'
      || previousLocationRef.current.pathname == '/shop/mission'
      || previousLocationRef.current.pathname == '/shop/mission/offerwall') {
      const badgeElement = document.querySelector('.grecaptcha-badge');

      if (badgeElement) {
        badgeElement.remove();
      }
    }

    if (!location.pathname.includes("block") && !location.pathname.includes("profiles")) {
      const myCookieValueok = Cookies.get('apikey');
      check_users_status(myCookieValueok);
    }
    previousLocationRef.current = location;
    // ... Tiếp tục xử lý và tải lại reCAPTCHA mới nếu cần

  }, [location.pathname]);
  function check_users_status(apikey) {
    if (apikey) {
      const users_status_cookies = Cookies.get('users_status');
      if (users_status_cookies) {
        set_users_status(users_status_cookies);
      }
      // alert_error(users_status_cookies);
      // alert_error(users_status_cookies);
      if (users_status) {
        if (users_status == '0') {
          process_block();
        }
      } else if (users_status_cookies) {
        if (users_status_cookies == '0') {
          process_block();
        }
      }
    }
  };
  function process_block() {
    alert_error('tài khoản bị khóa');
    setTimeout(function () {
      // Chuyển hướng sang trang web khác
      navigate("/shop/profiles/block");
    }, 1700);
  };
  const [apikeyExists, setApikeyExists] = useState(false);
  const [idExist, setIdExist] = useState(false);
  function checkshop() {
    const myCookieValue = Cookies.get('apikey');
    if (myCookieValue) {
      setTimeout(() => {
        checkshop2(myCookieValue);
      }, 100);
    }

  };
  function checkshop2(myCookieValue) {
    const docRef = doc(db, 'users', myCookieValue);
    getDoc(docRef).then((doc) => {
      if (doc.exists()) {
        setIdExist(true);
        Cookies.set('damoshop', 'ok');
      } else {
        setIdExist(false);
        Cookies.set('damoshop', 'no');
      }
    }).catch((error) => {
      console.log('Error getting document:', error);
    });
  };
  function switch_router(link) {
    setIsOpen(false);
    if (link == "/shop/support") {
      set_open_button_support(!open_button_support);
    }
    else {
      navigate(link);
    }

  };
  const handleChange = (event) => {
    const expirationDate = new Date();
    expirationDate.setFullYear(expirationDate.getFullYear() + 1);
    Cookies.set('main_domain', event.target.value, { expires: expirationDate });
    setDomain(event.target.value);
  };

  function checkcookie() {
    const expirationDate = new Date();
    expirationDate.setFullYear(expirationDate.getFullYear() + 1);
    const params = new URLSearchParams(window.location.search);
    const apikey = params.get('apikey');
    const webappmode = params.get('webappmode');
    const Type_user = Cookies.get('type_user');
    const national_market = params.get('national_market');
    const main_domain = params.get('main_domain');

    if (webappmode == 'showadview') {
      Cookies.set('webappmode', 'hust.media', { expires: expirationDate });
    }
    if (Type_user) {
      settype_user(Type_user);
    }

    if (national_market) {
      Cookies.set('national_market', national_market, { expires: expirationDate });
    }

    if (main_domain) {
      Cookies.set('main_domain', main_domain, { expires: expirationDate });
    } else {
      if (!Cookies.get("main_domain")) {
        Cookies.set(
          'main_domain',
          !isLocalHost(window.location.hostname) ? getMainDomain() : 'hust',
          { expires: expirationDate }
        );
      }
    }
    // alert('main_domain' + Cookies.get("main_domain"));

    if (apikey) {
      Cookies.set('apikey', apikey, { expires: expirationDate });
      setTimeout(() => {
        setApikeyExists('yes');
        checkshop2(apikey);
      }, 300);
    } else {
      checkdangnhap();
    }

  };
  const checkdangnhap = () => {
    const myCookieValue = Cookies.get('apikey');
    // console.log(123123123123);
    if (!myCookieValue || myCookieValue.length < 3) {
      setApikeyExists('no');
    }
    else {
      setApikeyExists('yes');
    }

  };

  useEffect(() => {
    checkcookie();
    checkshop();
  }, []);

  const [isOpen, setIsOpen] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(readSidebarCollapsed);

  useEffect(() => subscribeSidebarCollapsed(setIsCollapsed), []);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };
  const getMainDomain = () => {
    const hostname = window.location.hostname;
    const parts = hostname.split('.');
    // Nếu có nhiều hơn 2 phần, lấy phần thứ hai từ cuối, ngược lại lấy phần đầu tiên
    return parts.length > 2 ? parts[parts.length - 2] : parts[0];
  };
  const normalizedDomain = String(domain || Cookies.get("main_domain") || getMainDomain() || "").toLowerCase();
  const normalizedHostname = window.location.hostname.toLowerCase();
  const isBirdDomain =
    normalizedDomain.includes("bird") ||
    normalizedHostname.includes("bird");
  const pageShellClass = isBirdDomain
    ? "antialiased relative overflow-hidden min-h-screen min-h-[100dvh] flex flex-col"
    : "antialiased bg-gradient-to-r from-blue-200 via-purple-200 to-pink-200 min-h-screen min-h-[100dvh] flex flex-col";
  const pageShellStyle = isBirdDomain
    ? { background: "linear-gradient(135deg, #e7f7ff 0%, #ccecff 42%, #b8e0f7 72%, #f4fbff 100%)" }
    : undefined;
  return (
    <>
      <LocalhostNextAnchorRewrite />
      <Helmet>
        {/* <script src="https://hust.media/okok/assets/vendor/js/helpers.js"></script>
        <script src="https://hust.media/okok/assets/vendor/libs/perfect-scrollbar/perfect-scrollbar.js"></script> */}
        <link rel="stylesheet" href="https://hust.media/okok/dist/css/bootstrap.css" />
        <link rel="stylesheet" href="https://hust.media/okok/dist/css/bootstrap.min.css" />
      </Helmet>

      <div className="">

        <Navbar isOpen={isOpen} setIsOpen={setIsOpen} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} switch_router={switch_router}
          open_button_support={open_button_support} set_open_button_support={set_open_button_support} />

        <div
          className="flex-1 transition-all duration-300 md:ml-[var(--react-sidebar-width)]"
          style={{ '--react-sidebar-width': isCollapsed ? '72px' : '280px' }}
        >
          <div
            className={pageShellClass}
            style={pageShellStyle}>
            {isBirdDomain ? (
              <>
                <div className="pointer-events-none absolute left-24 top-28 h-32 w-32 rounded-full bg-[#ffe88a] shadow-[0_0_45px_rgba(255,216,94,0.55),0_0_110px_rgba(255,232,138,0.35)] sm:h-44 sm:w-44" />
                <div className="pointer-events-none absolute left-14 top-20 h-72 w-72 rounded-full bg-yellow-200/25 blur-3xl sm:h-96 sm:w-96" />
              </>
            ) : null}
            <div className="layout-wrapper layout-content-navbar relative z-10 flex-1 flex flex-col">
              <div className="layout-container flex-1 flex flex-col">
                <aside id="layout-menu" className="layout-menu menu-vertical menu bg-menu-theme">
                  <div style={{ position: "fixed" }} >
                    <br />

                    <div className="app-brand demo">
                      {/* <i className="bx bx-chevron-left bx-sm align-middle"></i> */}
                      <a className="layout-menu-toggle menu-link text-large ms-auto d-block d-xl-none">
                        <BiChevronLeft size={25} />
                      </a>
                    </div>
                    {/* <Sidebar apikeyExists={apikeyExists} switch_router={switch_router} type_user={type_user}
                  idExist={idExist} open_button_support={open_button_support} set_open_button_support={set_open_button_support} /> */}
                  </div>
                </aside>
                <div className=" layout-page flex flex-col flex-1 min-h-0">
                  <NavMain
                    toggleMenu={toggleMenu}
                    domain={domain}
                    handleChange={handleChange}
                  />
                  <div className="flex-1 flex flex-col min-h-[100dvh]">
                    <div className="flex-1 flex flex-col">
                      {(apikeyExists) ? (
                        <>
                          <div className="flex-1">
                            {(domain == "hust" && window.location.hostname == "hust.media" && apikeyExists == 'yes' &&
                              (!window.location.href.includes("thankiu") && !window.location.href.includes("profiles") && !window.location.href.includes("profile") && !window.location.href.includes("log_out") && !window.location.href.includes("auth") && !window.location.href.includes("posts") && !window.location.href.includes("hustadmin") && !window.location.href.includes("biolink"))) ? (
                              <Convert_domain />
                            ) : (
                              <Outlet />
                            )}
                          </div>
                          <SupportButton open_button_support={open_button_support} />

                          {apikeyExists == 'yes' && <Footer_app />}
                        </>
                      ) : (
                        <div style={{ textAlign: "center" }} className="mt-0   justify-center items-center ">
                          <div className="spinner-border text-primary" role="status"></div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {apikeyExists == 'no' && <Footer_web />}
          </div>
        </div>
      </div>
      <Helmet>

        {/* <script src="https://hust.media/okok/assets/js/config.js"></script>


        <script src="https://hust.media/okok/assets/js/main.js"></script> */}
      </Helmet>
    </>


  );
}

export default App;
